import React, { useEffect, useState } from "react";
import { TitleHeader } from "../../components/title-header";
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import {
  HelpDeskTicket,
  HelpDeskTicketStatus,
} from "../../types/help_desk_tickets.types";
import { useHelpDeskTickets } from "../../context/HelpDeskTicketsContext";
import { HelpDeskTicketForm } from "./hdt-form";
import { HDTDetail } from "./hdt-view-users";
import { HDTList } from "./hdtl-list";
import { Loading } from "../../components/loading";
import { ErrorMessage } from "../../components/error-message";

export const UsersHelpPage: React.FC = () => {
  const { userHDT, getUserHDTickets, isLoading, error } = useHelpDeskTickets();

  const [selectedRequest, setSelectedRequest] = useState<HelpDeskTicket | null>(
    null
  );

  const handleSelectRequest = (request: HelpDeskTicket) => {
    setSelectedRequest(request);
  };

  const handleBackToList = () => {
    setSelectedRequest(null);
  };

  const hasPendingTicket = userHDT?.some(
    (request) => request.status === HelpDeskTicketStatus.Pending
  );

  useEffect(() => {
    getUserHDTickets();
  }, [getUserHDTickets]);

  return (
    <div className="min-h-screen p-8">
      <div className="">
        <header className="mb-8">
          <TitleHeader title="Ayuda" icon={<QuestionMarkCircleIcon />} />

          <p className="text-gray-500 mt-1">
            Si necesitas ayuda, podes enviar una solicitud de ayuda.
          </p>
        </header>

        {error && (
          <div className="mb-4">
            <ErrorMessage message={error} dismissible />
          </div>
        )}

        {isLoading ? (
          <Loading />
        ) : selectedRequest ? (
          <HDTDetail hdTicket={selectedRequest} onBack={handleBackToList} />
        ) : (
          <div className="flex flex-col md:flex-row gap-8">
            <div className="md:w-1/2">
              <HelpDeskTicketForm
                hasPendingTicket={hasPendingTicket || false}
              />
            </div>
            <div className="md:w-1/2">
              <HDTList
                hdTickets={userHDT || []}
                onSelectRequest={handleSelectRequest}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
